/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Org_Models_Default_BadgeInputs */



/**
* | output |
* | --- |
* | "Default" |
*
* @param {Org_Models_Default_BadgeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const org_models_default_badge = /** @type {((inputs?: Org_Models_Default_BadgeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Org_Models_Default_BadgeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Standard")
	return /** @type {LocalizedString} */ ("Default")
});